import { useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { Typography } from "components/atoms";
import classNames from "classnames";
import { ArrowDownIcon, CloseIcon, Spinner } from "components/atoms/Icon";
import { useGetStudyPlannerEventQuery } from "services/studyPlanner";
import { FetchError } from "../FetchErrorMsg";
import { YellowClock } from "components/atoms/Icon/YellowClock";
import { Select } from "components/atoms/Icon/Select";
import { EmptyCircle } from "components/atoms/Icon/EmptyCircle";
import { formatDateDuration } from "utils/functions/formatDateDuration";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  id: number;
  editable: any;
}

export const StudyPlannerRescheduleDetailedCard = ({
  theme,
  id,
  editable,
}: IProps) => {
  const navigate = useNavigate();

  const [toggleView, setToggleView] = useState(false);
  const { isLoading, isError, data } = useGetStudyPlannerEventQuery(
    {
      eventId: id,
    },
    { skip: id === undefined || id === null }
  );

  return (
    <div className="reschedule-detailed-section" key={id}>
      {isLoading ? (
        <Spinner theme={theme} />
      ) : isError ? (
        <FetchError content="Oops! failed to load resources." />
      ) : (
        data && (
          <>
            <div
              className={classNames({
                "top-detailed-section": true,
                "diagnostic-exam": data.EventType === "Diagnostic",
                "homework-tile": data.EventType === "Homework",
                "additional-tile":
                  data.EventType !== "Homework" &&
                  data.EventType !== "Diagnostic" &&
                  data.EventType !== "TestSegment" &&
                  data.EventType !== "ClassSegment" &&
                  data.EventType !== "TestDay" &&
                  data.EventType !== "Prework",
              })}
            >
              <div
                className={classNames({
                  "close-icon-row": true,
                  rotate: toggleView,
                })}
              >
                <ArrowDownIcon
                  theme={theme}
                  color={theme === "light" ? "#9D9D9D" : "#12131A"}
                  onClick={() => setToggleView((prev) => !prev)}
                />
              </div>
              <div className="first-row">
                <div className="top-left-content">
                  <Typography
                    styles="title"
                    label={data.Title}
                    variant="h7Bold"
                  />
                </div>
                <div className="top-right-content">
                  <Typography
                    label={`aprox: ${
                      data.TimeEstimate === 0 || data.TimeEstimate === null
                        ? "0 min"
                        : formatDateDuration(data.TimeEstimate)
                    }`}
                    variant="h9Medium"
                    styles="top-right-content-typography-custom-style"
                  />
                </div>
              </div>
              {data.EventType === "Homework" ||
              data.EventType === "Diagnostic" ||
              data.EventType === "Prework" ? (
                <div className="second-row">
                  <Typography
                    label={
                      data.EventType &&
                      data.EventType.replace(/([A-Z])/g, " $1").trim()
                    }
                    variant="h8Med"
                    styles="second-row-typography-custom-style"
                  />
                </div>
              ) : null}
              <div className="third-row">
                <div className="left-section">
                  <div className="scheduled-date-section">
                    <Typography
                      label="Scheduled Date"
                      variant="h8Med"
                      styles="second-row-typography-custom-style"
                    />
                  </div>
                  <div className="calender-section">
                    <Typography
                      label={dayjs(data.ScheduledDate).format("MM/DD/YYYY")}
                      variant="h8Book"
                      styles="second-row-typography-custom-style"
                    />
                  </div>
                </div>
              </div>
            </div>
            {toggleView ? (
              <div className="bottom-icon-text-section">
                {data.Items && Array.isArray(data.Items)
                  ? data.Items.map((obj: any, index: number) => (
                      <div className="icon-text-wrapper" key={index}>
                        {obj.Status === "Inprogress" ||
                          obj.Status === "InProgress" ||
                          obj.Status === "In-Progress" ? (
                          <div className="icon-wrapper">
                            <YellowClock />
                          </div>
                        ) : obj.Status === "Complete" ||
                          obj.Status === "Completed" ? (
                          <div className="icon-wrapper">
                            <Select />
                          </div>
                        ) : obj.Status === "Todo" ||
                          obj.Status === "Pending" ? (
                          <div className="icon-wrapper">
                            <EmptyCircle theme={theme} />
                          </div>
                        ) : (
                          <div className="icon-wrapper">
                            <Select />
                          </div>
                        )}
                        <Typography
                          variant="h8Med"
                          label={obj.Title}
                          onClick={() => window.open(obj.LaunchUrl, "__blank")}
                          styles="launch-item-text"
                        />
                      </div>
                    ))
                  : null}
              </div>
            ) : null}
          </>
        )
      )}
    </div>
  );
};
